module.exports = {
	"classes": [
		"retail-page",
		"header-dark"
	],
	"title": "Retail",
	"metas": {
		"description": "Increase conversions, personalize engagement, streamline partnerships, and build brand loyalty."
	},
	"opengraph": {
		"og:title": "Retail",
		"og:description": "Increase conversions, personalize engagement, streamline partnerships, and build brand loyalty.",
		"og:url": "https://auth0.com/retail",
		"og:image": "https://cdn.auth0.com/website/retail-twitter-card.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/retail-twitter-card.png"
	},
	"twittercard": {
		"twitter:title": "Retail",
		"twitter:description": "Increase conversions, personalize engagement, streamline partnerships, and build brand loyalty.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/retail-twitter-card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/retail/metadata.json
// module id = 1431
// module chunks = 0